import { makeRequest } from './client';

const login = async (body) => {
  return await makeRequest(`auth/login`, {
    method: 'POST',
    body: body,
  });
};

const logout = async () => {
  return await makeRequest(`auth/logout`, {
    method: 'POST',
  });
};

const register = async (body) => {
  return await makeRequest(`auth/register`, {
    method: 'POST',
    body: body,
  });
};

const verifyEmail = async () => {
  return await makeRequest(`auth/email-verification`, {
    method: 'GET',
  });
};

const confirmEmail = async (token) => {
  return await makeRequest(`auth/verify-email/${token}/`, {
    method: 'GET',
  });
};

const forgotPassword = async (body) => {
  return await makeRequest(`auth/forgot-password`, {
    method: 'POST',
    body,
  });
};

const setNewPassword = async (body, token) => {
  return await makeRequest(`auth/reset-password/${token}/`, {
    method: 'POST',
    body,
  });
};

const changePasswordRequest = async (body) => {
  return await makeRequest(`auth/change-password`, {
    method: 'POST',
    body: body,
  });
};

const google = async (body) => {
  return await makeRequest(`auth/google`, {
    method: 'POST',
    body: body,
  });
};

export {
  register,
  verifyEmail,
  confirmEmail,
  login,
  logout,
  forgotPassword,
  setNewPassword,
  changePasswordRequest,
  google,
};
